<div id="alert-wrap" class="alerty {{alertType}}">
    <div class="alert-message">{{alertMessage}}</div>
    <div class="alert-close"></div>
</div>